window.thisurl = window.location.host;
window.webname = "\u6D77\u5357\u78A7\u5F71\u79D1\u6280\u6709\u9650\u516C\u53F8";
window.webdizhi = "\u6D77\u5357\u7701\u6D77\u53E3\u5E02\u9F99\u534E\u533A\u5927\u540C\u8857\u9053\u4E49\u9F99\u897F\u8DEF21\u53F7\u4FA8\u6C47\u5927\u53A63\u5C42\u4F01\u6167\u521B\u4E1A\u56EDA-281\u53F7";
window.webhaoma = "";
window.webemail = "";
window.webbeian = "\u743CICP\u59072022012788\u53F7-2";
window.webqq = "";
window.webyoubian = "";

//# sourceMappingURL=mycsgo-china-proxy2.8528d495.js.map
